import { NgFor } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ConnectionStatus } from '@capacitor/network';
import { HelperFunctions, IPhoto, ISubPhoto, PhotoSizes } from '@curbnturf/entities';
import { PlatformService } from '@curbnturf/network/src/lib/platform/platform.service';
import { PhotoService } from '@curbnturf/photo';
import { StatusFacade } from '@curbnturf/status';
import { IonicModule, ModalController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { default as Swiper, default as SwiperCore, Keyboard, Navigation, Pagination, Zoom } from 'swiper';

SwiperCore.use([Keyboard, Navigation, Pagination, Zoom]);

@Component({
  selector: 'curbnturf-photo-display-modal',
  templateUrl: './photo-display-modal.component.html',
  styleUrls: ['./photo-display-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, NgFor],
})
export class PhotoDisplayModalComponent implements OnInit, OnDestroy {
  @Input() photos: ISubPhoto[];

  photoUris: string[] = [];

  allowNavigation: boolean = true;

  swiper: Swiper;

  subscriptions: Subscription[] = [];
  connectionStatus: ConnectionStatus = { connected: true, connectionType: 'wifi' };

  getPhotoUrl = HelperFunctions.getPhotoUrl;

  constructor(
    private modalController: ModalController,
    private photoService: PhotoService,
    private platformService: PlatformService,
    private statusFacade: StatusFacade,
  ) {}

  ngOnInit() {
    this.swiper = new Swiper('.swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      zoom: {
        maxRatio: 5,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });

    this.subscriptions.push(
      this.statusFacade.networkStatus$.subscribe(async (status) => {
        this.connectionStatus = status;
        this.photoUris = [];
        if (this.photos && this.photos.length > 0) {
          for (const photo of this.photos) {
            this.photoUris.push(await this.getPhoto(photo));
          }
        }
      }),
    );

    if (this.platformService.isPhoneSize()) {
      this.allowNavigation = false;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => {
      if (!sub.closed) {
        sub.unsubscribe();
      }
    });
  }

  async getPhoto(photo: IPhoto) {
    if (this.connectionStatus.connected) {
      return this.photoService.getPhotoOnline(photo, PhotoSizes.Original);
    } else {
      return await this.photoService.getPhotoOffline(photo);
    }
  }

  async dismissModal() {
    await this.modalController.dismiss();
  }
}
